
































import Vue from "vue";
import iwClassifiedsListHeader from "./ClassifiedsListHeader.vue";
import iwClassifiedsListItem from "./ClassifiedsListItem.vue";
import iwClassifiedItemSkeleton from "./ClassifiedItemSkeleton.vue";
import { Classified } from "@/shared/interfaces/classified/Classified.interface";

export default Vue.extend({
    name: "ClassifiedsList",

    components: {
        iwClassifiedsListHeader: iwClassifiedsListHeader,
        iwClassifiedsListItem: iwClassifiedsListItem,
        iwClassifiedItemSkeleton: iwClassifiedItemSkeleton
    },

    props: {
        classifieds: {
            type: Array as () => Classified[],
            required: true
        },
        isLoading: {
            type: Boolean,
            required: false,
            default: false
        },
        hasError: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    computed: {
        showHeader: function(): boolean {
            return this.isLoading || (!this.hasError && this.classifieds.length > 0);
        }
    }
});
